module.exports = __webpack_public_path__ + "img/2.537b9276.png";